import { notificationActions } from "../reducers/notificationSlice";

let hideNotificationTimeout: ReturnType<typeof setTimeout> | undefined;

export function showNotification(
  dispatch: any,
  isVisible: boolean,
  messageBarType: any,
  message: any,
  url: string
) {
  if (hideNotificationTimeout) {
    clearTimeout(hideNotificationTimeout);
    hideNotificationTimeout = undefined;
  }

  dispatch(
    notificationActions.showNotification({
      isVisible: isVisible,
      notificationDetails: [
        {
          type: messageBarType,
          message: message,
          sourcePageURL: url,
        },
      ],
    })
  );
}
export function hideNotification(dispatch: any, duration: number) {
  if (hideNotificationTimeout) {
    clearTimeout(hideNotificationTimeout);
  }

  hideNotificationTimeout = setTimeout(() => {
    dispatch(notificationActions.hideNotification());
    hideNotificationTimeout = undefined;
  }, duration);
}
